export const MarketplaceItemConfig = {
  priceCentsMin: 1,
  priceCentsMax: 4294967295, // MySQL unsigned integer

  quantityMax: 9999,
  quantityMin: 1,

  nameMaxLength: 255,
  nameMinLength: 1,

  descriptionMaxLength: 4000,
  descriptionMinLength: 1,
};

export const DefaultPerPage = 60;

// Ideally the FE shouldn't know these values at all — it should come from the API
// directly in the item data (e.g. as an `expirationDays` or `expiresAt` field).
export const ExpirationDays = 30;
export const ExpirationSoonDays = 8; // Use 8 days because there is some "floating" window in API. It can be 6-8 days in fact.
